import HamburgerMenu from "./HamburgerMenu";

const Header = () => {
  return (
    <header className="site-header">
      <div className="container header-inner">

        {/* Logo + Brand */}
        <div className="header-brand">
          <img
            src="/images/logo.png"
            alt="Popular Watch and Opticals Logo"
            className="header-logo"
          />

          <div className="brand-text">
            <h1 className="brand-title">
              Popular Watch & Opticals
            </h1>
            <p className="brand-tagline">
              Eye Care • Spectacles • Watches
            </p>
          </div>
        </div>

        {/* Hamburger */}
        <HamburgerMenu />

      </div>
    </header>
  );
};

export default Header;
